export default "__VITE_ASSET__c7045e55__"